import { render, staticRenderFns } from "./iar.vue?vue&type=template&id=875cc448&"
import script from "./iar.vue?vue&type=script&lang=js&"
export * from "./iar.vue?vue&type=script&lang=js&"
import style0 from "./iar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports